import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";

/**
 * A generic component to scroll to the first field with an error upon Formik submission.
 * @param {Object} fieldRefs - An object mapping Formik field names to their corresponding React refs.
 *                              Example: {{ email: emailRef, password: passwordRef }}
 */
const ScrollToError = ({ fieldRefs }) => {
	const { submitCount, isValid, errors } = useFormikContext();
	const lastSubmitCount = useRef(submitCount);

	useEffect(() => {
		if (submitCount > lastSubmitCount.current) {
			lastSubmitCount.current = submitCount;
			if (!isValid) {
				for (const key of Object.keys(fieldRefs)) {
					if (errors[key] && fieldRefs[key]?.current) {
						fieldRefs[key].current.scrollIntoView({ behavior: "smooth", block: "center" });
						fieldRefs[key].current.focus();
						break;
					}
				}
			}
		}
	}, [submitCount, isValid, errors, fieldRefs]);

	return null;
};

export default ScrollToError;
